import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api, get } from '../../lib/api';

const API_URL = '/api/changelog_releases';

const fetchChangelogReleases = async () => {
  return get(API_URL);
};

export const useChangelogRelease = id => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['changelogRelease', id],
    queryFn: () => get(`${API_URL}/${id}`),
    enabled: !!id,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return {
    release: data?.data ?? null,
    isLoading,
    error,
  };
};

export const useChangelogReleases = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['changelogReleases'],
    queryFn: fetchChangelogReleases,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return {
    releases: data?.data ?? [],
    isLoading,
    error,
  };
};

export const useCreateRelease = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: releaseData =>
      api.post(API_URL, { changelog_release: releaseData }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['changelogReleases'] });
      queryClient.invalidateQueries({ queryKey: ['changelog'] });
    },
  });
};

export const useUpdateRelease = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, ...releaseData }) =>
      api.patch(`${API_URL}/${id}`, { changelog_release: releaseData }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['changelogReleases'] });
      queryClient.invalidateQueries({ queryKey: ['changelog'] });
    },
  });
};

export const useDeleteRelease = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: id => api.delete(`${API_URL}/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['changelogReleases'] });
    },
  });
};
